












































import Vue from "vue";
import "@infoland/iprova-api"; //imports extension for date formatting
import Utils from "../../../utils";
import { NewsArticle, news_article_type } from "@infoland/iprova-api";

export default Vue.extend({
    name: "NewsArticleListItem",
    props: {
        onClickFunction: { type: Function, default: () => 1 },
        portalId: Number,
        newsArticle: Object as () => NewsArticle
    },
    data: () => ({
        isDocumentArticle: false as boolean,
        articleElement: {} as Element,
        expanded: false as boolean,
        isTruncated: false as boolean
    }),
    mounted() {
        this.isDocumentArticle = this.newsArticle.type == news_article_type.content_item;

        if (this.isDocumentArticle) {
            this.articleElement = this.$refs.newsArticleSubtitle as Element;
            //this.articleElement = document.getElementById("newsArticleListItemSubtitle1_" + this.newsArticle.news_article_id) as Element;

            const observer = new ResizeObserver(entries => {
                for (let entry of entries) {
                    this.isTruncated = entry.target.scrollHeight > Math.ceil(entry.contentRect.height);
                    entry.target.classList[this.isTruncated ? "add" : "remove"]("truncated");
                }
            });
            observer.observe(this.articleElement);
        }
    },
    computed: {
        toggleButtonText(): string {
            return this.$t(this.expanded ? "clamp.readLess" : "clamp.readMore") as string;
        }
    },
    methods: {
        toCalendar(itemDate: Date): string {
            return Utils.formatDateToCalendar(itemDate);
        },
        isSummaryAvailable(item) {
            if (item.summary) {
                return true;
            } else {
                return false;
            }
        },
        setListItemTitle(item) {
            if (item.type == news_article_type.content_item && item.content_item) {
                return item.content_item.title;
            } else {
                return item.title;
            }
        },
        setSubTitle(item: NewsArticle): string {
            const title = item.content_item ? item.title + ` ${item.summary}` : item.summary;
            return item.created_on_date_time ? `${this.toCalendar(item.created_on_date_time.toDate())} - ${title}` : title;
        },
        toggleExpanded() {
            this.expanded = !this.expanded;
            (document.getElementById("newsArticleListItemSubtitle1_" + this.newsArticle.news_article_id) as HTMLInputElement).classList[
                this.expanded ? "add" : "remove"
            ]("expanded");
        }
    }
});
